import * as React from 'react'
import { Button } from '@design/pt-ui'
import { translateWithUserLocale } from '../utils/i18n'
import { Edit as EditIcon } from '@mui/icons-material'

interface IEditButtonProps {
  disabled?: boolean
  onClick?: () => any
}

function EditButton(props: IEditButtonProps) {
  return (
    <Button
      size="small"
      variant="outlined"
      disabled={props.disabled}
      onClick={props.onClick}
      color="inherit"
      sx={{
        padding: 0,
        paddingLeft: '10px',
        paddingRight: '10px',
        marginLeft: '15px',
        minHeight: '26px',
      }}
      startIcon={
        <EditIcon
          sx={{ fontSize: '14px !important', width: '14px', height: '14px' }}
        />
      }>
      {translateWithUserLocale('edit')}
    </Button>
  )
}

export default EditButton
